/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Speak_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to talk in voice channels. If this permission is disabled, members are default muted until somebody with the ‘Mute Members’ permission unmutes..." |
*
* @param {Leveling_Perm_Speak_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_speak_hint = /** @type {((inputs?: Leveling_Perm_Speak_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Speak_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам говорить в голосовых каналах. Если право отключено, микрофон у участников по умолчанию выключен, пока его не включит кто-то с правом «Отключать микрофоны участникам».")
	return /** @type {LocalizedString} */ ("Allows members to talk in voice channels. If this permission is disabled, members are default muted until somebody with the ‘Mute Members’ permission unmutes them.")
});